require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-learn-the-basics-of-sass-and-compass.json") })
        }
      }, "path---blog-learn-the-basics-of-sass-and-compass");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-learn-the-basics-of-sass-and-compass!./.cache/json/blog-learn-the-basics-of-sass-and-compass.json
// module id = 940
// module chunks = 231608221292675